// @flow

export { default as cache } from 'universal/reducers/cache';
export { default as cart } from 'client/reducers/cart';
export { default as contentfulData } from 'client/reducers/contentful';
export { default as ifpApps } from 'client/reducers/ifpApps';
export { default as optimizely } from 'client/reducers/optimizely';
export { default as siteConfigs } from 'client/reducers/siteConfigs';
export { default as translations } from 'client/reducers/translations';
export { default as user } from 'client/reducers/user';
export const brand = (state: string = 'stride') => state;
export const phase3Enabled = (state: boolean | null = null) => state;
export const personId = (state: string | null = null) => state;
export const allowGaAccess = (state: boolean | null = null) => state;
